module.exports = __webpack_public_path__ + "static/media/affiliate.8534a3dd.jpg";